import React, { Component } from 'react';
import { connect } from 'react-redux'
import { CardNumberElement, } from "@stripe/react-stripe-js";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid'
import StripeCardsSection from './StripeCardSection'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

import { svgAsPngUri } from "save-svg-as-png";

import LocalShipping from '@material-ui/icons/LocalShipping';
import Email from '@material-ui/icons/Email';
import Typography from '@material-ui/core/Typography';
import { emptyCart } from '../actions'

import store from '../index';

let lightcss = '<style>#poster{background-color:white;}.roads{fill:none;stroke:#222;stroke-width:1;opacity:1;}.buildings{fill:#444;opacity:1;stroke:#444;}.landuse{fill:transparent;opacity:1;stroke:#CCC;}.water{opacity:1;fill:#EEE;stroke:#444;}.waterway{opacity:1;fill:none;stroke:#444;}#textRect{opacity:0.95;fill:#FFF;stroke-width:0;}#title{fill:#000;font-size:200%;}#subtitle{fill:#000;font-size:120%;}.text{fill:#000;}.day{fill:#444;stroke:#fff;}.axis line{stroke:#000;}.axis path{stroke:#000;}.axis text{fill:#000;}</style>';
let darkcss = '<style>#poster{background-color:#444;}.roads{fill:none;stroke:#CCC;stroke-width:1;opacity:1;}.buildings{fill:#222;opacity:1;stroke:#222;}.landuse{fill:transparent;opacity:1;stroke:#CCC;}.water{opacity:1;fill:#888;stroke:#222;}.waterway{opacity:1;fill:none;stroke:#222;}#textRect{opacity:0.7;fill:#000;stroke-width:0;}#title{fill:#FFF;font-size:200%;}#subtitle{fill:#FFF;font-size:120%;}.text{fill:#FFF;}.day{fill:#CCC;stroke:#444;}.axis line{stroke:#FFF;}.axis path{stroke:#FFF;}.axis text{fill:#FFF;}</style>';

class CheckoutForm extends Component {
    constructor(props) {
        super(props);
        let pp = this
        fetch('/countries.json').then(function (response) {
            console.log(response.text)
            return response.json();
        })
            .then(function (json) {
                pp.setState({
                    countries: json.result,
                    states: json.result.filter(country => country.code === 'US')[0].states
                })
            });
        this.state = {
            countries: [],
            states: [],
            complete: false,
            emailError: false,
            nameError: false,
            addressError: false,
            zipError: false,
            cityError: false,
            stateError: false,
            countryError: false,
            disabled: false,
            errorMessage: '',

            amount: this.props.amount,

            email: '',
            name: '',
            address: '',
            zip: '',
            city: '',
            state: '',
            country: 'US/United States'
        };
        this.submit = this.submit.bind(this);
    }

    async submit(ev) {

        //Validation
        if (this.state.email === '') {

            this.setState({
                errorMessage: 'Email is incomplete'
            })
            return
        }
        if (this.state.emailError) {

            this.setState({
                emailError: true,
                errorMessage: 'Email is incorrect'
            })
            return
        }

        if (this.props.format === 'Poster') {
            if (this.state.name === '' || this.state.address === '' || this.state.city === '' || this.state.zip === '' || this.state.country === '') {

                this.setState({
                    errorMessage: 'Address is incomplete'
                })
                return
            }
        }

        //Stripe payment if amount is not zero
        if (this.state.amount > 0) {
            console.log('ask Stripe paymentMethod');
            const cardElement = this.props.elements.getElement(CardNumberElement);
            let { paymentMethod } = await this.props.stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            console.log('Received Stripe token:', paymentMethod);
            if (!paymentMethod) {
                this.setState({
                    errorMessage: 'Payment information is incorrect'
                })
                return
            }

            this.setState({
                disabled: true,
                errorMessage: 'Processing...'
            })

            if (paymentMethod) {
                await this.pay(this, paymentMethod, "Method");
            }

        } else {
            await this.pay(this, null, null);
        }

    }

    handleServerResponse = (checkoutForm, response) => {
        if (response.error) {
            // Show error from server on payment form
            checkoutForm.setState({ errorMessage: "Checkout aborted. Please try later" });
        } else if (response.requires_action) {
            // Use Stripe.js to handle required card action
            checkoutForm.handleAction(checkoutForm, response);
        } else {
            // Show success message
            checkoutForm.props.dispatch(emptyCart())
            checkoutForm.setState({ complete: true });
        }
    }

    //Used for 3D Secure
    handleAction = async (checkoutForm, response) => {
        let result = await checkoutForm.props.stripe.handleCardAction(
            response.payment_intent_client_secret
        )
        if (result.error) {
            // Show error in payment form
            checkoutForm.setState({ errorMessage: "Checkout aborted. Please try later" });
        } else {
            await checkoutForm.pay(checkoutForm, result.paymentIntent, "Intent")
        }
    }

    //mode is Method or Intent to set payment_method_id or payment_intent_id
    pay = async (checkoutForm, payment, mode) => {
        let body = {
            email: checkoutForm.state.email,
            shipping: {
                name: checkoutForm.state.name,
                address: checkoutForm.state.address,
                zip: checkoutForm.state.zip,
                city: checkoutForm.state.city,
                state: checkoutForm.state.state.split('/')[1],
                state_code: checkoutForm.state.state.split('/')[0],
                country: checkoutForm.state.country.split('/')[1],
                country_code: checkoutForm.state.country.split('/')[0]
            },
            description: checkoutForm.props.title,
            format: checkoutForm.props.format,
            amount: checkoutForm.props.amount,
            voucher: checkoutForm.props.voucher,
            voucherAmount: checkoutForm.props.voucherAmount,
            items: store.getState().app.cart
        };
        if (payment) {
            mode === "Method" ? body.payment_method_id = payment.id : body.payment_intent_id = payment.id;
        }

        let response = await fetch(global.serverUrl + "/pay", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });


        if (response.ok) {
            response.json().then(data => {
                console.log(data);
                checkoutForm.handleServerResponse(checkoutForm, data);
            });
            //await handleServerResponse(await response.json());
        } else {
            checkoutForm.setState({ errorMessage: "Checkout aborted. Please try later" });
        }
    }

    handleValidation = (e) => {
        console.log(e.target.id);
        var obj = {};
        obj[e.target.id] = e.target.value;
        this.setState(obj)
        if (e.target.id === 'email') {
            if (e.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && e.target.value !== '') {
                this.setState({
                    emailError: false,
                    errorMessage: ''
                })
            } else {
                this.setState({
                    emailError: true,
                    errorMessage: 'Email is incorrect'
                })
            }
        }

    }

    handleImageCreation = () => {
        return new Promise(function (resolve, reject) {
            //saveSvgAsPng(document.getElementById("poster"), "map.png", { scale: 11.812, encoderOptions: 1 });
            //3600x4800px = 12x16inch at 300DPI = scale : 7.5 (4800/640) where 640 = height of the poster on screen
            svgAsPngUri(document.getElementById("poster"), { scale: 7.5, encoderOptions: 1 }, function (png) {

                if (png) {
                    var data = png.replace(/^data:image\/\w+;base64,/, '');
                    //console.log(data);

                    let svg = document.getElementById("poster").outerHTML;
                    if (svg.indexOf('theme/light.css') === -1) {
                        svg = svg.replace('<style></style>', darkcss);
                    } else {
                        svg = svg.replace('<style></style>', lightcss);
                    }
                    resolve({ data: data, svg: svg });
                } else {
                    reject("Error!")
                }

            })
        })
    }

    handleSelectStateChange = event => {
        this.setState({ state: event.target.value });
    };

    handleSelectCountryChange = event => {
        if (event.target.value !== 'US/United States') {
            this.setState({ state: '' });
        }
        this.setState({ country: event.target.value });
    };

    render() {
        console.log('FORMAT', this.props.format)
        const successMessage = <div><h3>Purchase Complete</h3><span>Thank you for your payment. Your order has been successfully registered. We'll email you an order confirmation with details and tracking info.</span></div>
        if (this.state.complete) return successMessage;

        return (
            <div className="checkout">
                {/*<CardElement/>*/}
                <Grid container spacing={2}>
                    <Grid item xs={this.props.format === 'Digital' ? 12 : 6}>
                        <Grid container>
                            <Grid item xs={1}>
                                <Email style={{ marginTop: 4 }} />
                            </Grid>
                            <Grid item xs={11}>
                                <Typography variant="h6" > Email</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    error={this.state.emailError}
                                    onChange={this.handleValidation}
                                    value={this.state.email}
                                    id="email"
                                    label="Email"
                                />
                            </Grid>
                            <br /><br /><br /><br /><br /><br />
                            {this.props.amount !== 0 && <Grid item xs={12}>
                                <StripeCardsSection elements={this.props.elements} stripe={this.props.stripe} />
                            </Grid>}
                        </Grid>
                    </Grid>
                    {this.props.format === 'Poster' &&
                        <Grid item xs={6}>
                            <Grid container>
                                <Grid item xs={1}>
                                    <LocalShipping style={{ marginTop: 4 }} />
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography variant="h6" > Shipping address</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        error={this.state.nameError}
                                        onChange={this.handleValidation}
                                        value={this.state.name}
                                        id="name"
                                        label="Name"
                                    /><br />
                                    <TextField
                                        required
                                        fullWidth
                                        error={this.state.addressError}
                                        onChange={this.handleValidation}
                                        value={this.state.address}
                                        id="address"
                                        label="Address"
                                    /><br />
                                    <TextField
                                        required
                                        fullWidth
                                        error={this.state.zipError}
                                        onChange={this.handleValidation}
                                        value={this.state.zip}
                                        id="zip"
                                        label="Zip"
                                    /><br />
                                    <TextField
                                        required
                                        fullWidth
                                        error={this.state.cityError}
                                        onChange={this.handleValidation}
                                        value={this.state.city}
                                        id="city"
                                        label="City"
                                    /><br />
                                    <FormControl fullWidth style={{ marginTop: 10 }}>
                                        <InputLabel shrink htmlFor="age-label-placeholder">
                                            State
                                        </InputLabel>
                                        <Select
                                            value={this.state.state}
                                            onChange={this.handleSelectStateChange}
                                            input={<Input name="age" id="age-label-placeholder" />}
                                            displayEmpty
                                            name="state"
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {this.state.states.map(function (state, i) {
                                                return <MenuItem value={state.code + '/' + state.name} key={i}>{state.name}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl><br />
                                    <FormControl fullWidth style={{ marginTop: 10 }}>
                                        <InputLabel shrink htmlFor="age-label-placeholder">
                                            Country *
                                        </InputLabel>
                                        <Select
                                            value={this.state.country}
                                            onChange={this.handleSelectCountryChange}
                                            input={<Input name="age" id="age-label-placeholder" />}
                                            displayEmpty
                                            name="country"
                                        >
                                            {this.state.countries.map(function (country, i) {
                                                return <MenuItem value={country.code + '/' + country.name} key={i}>{country.name}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl><br />
                                </Grid>
                            </Grid>
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <div style={{ display: 'flex' }}>
                            <Button variant="contained" color="primary" disabled={this.state.disabled} onClick={this.submit} style={{ marginTop: 10 }}>Pay {this.props.amount}.00$</Button>
                            <div style={{ marginTop: 20, marginLeft: 10 }}>{this.state.errorMessage}</div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default connect()(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/CheckoutForm.js